import "./tag-list.scss";
import $ from "jquery";
window.$ = window.jQuery = $;
require("bootstrap");
require("bootstrap-3-typeahead");

window.app.directive("tagList", [
  function() {
    return {
      restrict: "E",
      scope: {
        ngModel: "=",
        header: "@",
        headerClass: "@",
        emptyMsg: "@",
        emptyClass: "@",
        placeholder: "@",
        disabled: "@",
        choices: "&",
        allowFreeText: "&",
        displayField: "@",
        idField: "@"
      },
      template: (tElement, tAttrs) => {
        tElement.html(require("./tag-list.html"));
        // tElement.addClass('material simple-datepicker move-label');
        tElement.css("overflow", "visible");
      },
      controller: [
        "$scope",
        "$element",
        "$state",
        "$timeout",
        function($scope, $element, $state, $timeout) {
          $scope.randId = "_tli" + Math.floor(Math.random() * 9999999);
          $scope.tagInput = "";
          $scope.empty = () => !$scope.ngModel || !$scope.ngModel.length;
          $scope.del = index => {
            $scope.ngModel.splice(index, 1);
          };

          $scope.onEnter = () => {
            console.warn("onEnter allowFreeText is", $scope.allowFreeText());
            if (!$scope.allowFreeText()) return;
            const ta = $("#" + $scope.randId + "+ .typeahead")[0];
            if (ta && ta.style.display !== "none") {
              // console.warn('Skipping onEnter because of typeahead');
              return;
            }
            if (!$scope.tagInput) return;
            $timeout(() => {
              $scope.ngModel.push($scope.tagInput);
              $scope.tagInput = "";
            }, 50);
          };

          const getChoices = (q, cb) => {
            const equals = (a, b) =>
              $scope.idField
                ? a[$scope.idField] === b[$scope.idField]
                : a === b;

            cb(
              $scope
                .choices()
                .filter(tag => !$scope.ngModel.find(item => equals(item, tag)))
            );
          };

          setTimeout(() => {
            console.warn("About to init typeahead on " + $scope.randId);
            $("#" + $scope.randId).typeahead({
              fitToElement: true,
              items: "all",
              source: getChoices, //$scope.choices(),
              displayText: x =>
                $scope.displayField ? x[$scope.displayField] : x,
              afterSelect: x => {
                $timeout(() => {
                  $scope.ngModel.push(x);
                  $scope.tagInput = "";
                }, 0);
                // $('#' + $scope.randId).val('');
              }
            });
          }, 0);
        }
      ]
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/tag-list/tag-list.js